import React from "react";
import { BinanceStable, useBinanceTicker } from "../hooks/useBinanceTicker";

type BalanceInfo = {
    asset: string;
    free: string;
    locked: string;
};

type SymbolData = {
    available: number;
    onOrder: number;
    total: number;
    info: BalanceInfo;
};

type Props = {
    symbol: SymbolData;
    price: string;
};

const stable = BinanceStable.FDUSD;

export const BalanceCard: React.FC<Props> = ({ symbol, price }) => {
    const { connected, isStable } = useBinanceTicker(symbol.info.asset, stable);

    return (
        <div className="bg-white rounded-xl shadow p-5 border border-gray-200">
            <div className="flex justify-between items-center space-x-3 mb-4">
                <h3 className="text-xl font-semibold">
                    Баланс {symbol.info.asset}
                </h3>
                {isStable ? null : (<span
                    className={
                        "text-xs px-2 rounded-full " +
                        (connected
                            ? "bg-green-100 text-green-700"
                            : "bg-gray-200 text-gray-600")
                    }
                >
                    {connected ? "online" : "offline"}
                </span>)}

            </div>

            <div className="space-y-2 text-gray-700">
                <div className="flex justify-between">

                    <span className="font-medium">Цена ({stable.toUpperCase()}):</span>
                    <span>{parseFloat(price ?? "0").toFixed(2)}</span>
                </div>
                <div className="flex justify-between">
                    <span className="font-medium">Доступно:</span>
                    <span>{parseFloat(symbol.available.toString()).toFixed(2)}</span>
                </div>

                <div className="flex justify-between">
                    <span className="font-medium">В ордерах:</span>
                    <span>{parseFloat(symbol.onOrder.toString()).toFixed(2)}</span>
                </div>

                <div className="flex justify-between">
                    <span className="font-medium">Всего:</span>
                    <div className="flex flex-col gap-y-1 text-right">
                        <span>{isStable ? '$' : ''}{parseFloat(symbol.total.toString()).toFixed(2)}</span>
                        {isStable ? null : <span className="text-sm text-gray-500">${(parseFloat(symbol.total.toString()) * parseFloat(price ?? "0")).toFixed(2)}</span>}
                    </div>
                </div>
            </div>
        </div>
    );
};